import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { isWikiImageUrl, wikiHeadingPlugin } from '@/lib/wiki-content';

type WikiMarkdownProps = {
  content: string;
  headingPrefix?: string;
};

export function WikiMarkdown({ content, headingPrefix = 'wiki-preview' }: WikiMarkdownProps) {
  return (
    <div className="wiki-markdown">
      <Markdown remarkPlugins={[remarkGfm, wikiHeadingPlugin(headingPrefix)]} skipHtml
        components={{
          table: ({ children }) => <div className="overflow-x-auto"><table>{children}</table></div>,
          img: ({ src, alt }) => src && isWikiImageUrl(src) ? <img src={src} alt={alt ?? ''} loading="lazy" className="h-auto max-w-full rounded-xl" /> : null,
        }}>
        {content}
      </Markdown>
    </div>
  );
}
